<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="物流单号">
              <a-input v-model.trim="queryParam.logisticsNo" placeholder/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="车号">
              <a-input v-model.trim="queryParam.vehicleNo" placeholder/>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="卡号">
                <a-input v-model.trim="queryParam.cardNo" placeholder/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="业务类型">
                <a-select
                  v-model="queryParam.businessTypeId"
                  :filterOption="filterOption"
                  @change="handleBizChange"
                  placeholder="请选择"
                >
                  <a-select-option value>全选</a-select-option>
                  <a-select-option v-for="(item, index) in bizList" :key="index" :value="item.id">{{
                    item.name
                    }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="物流状态">
                <a-select v-model="queryParam.logStatus" :filterOption="filterOption" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option v-for="(item, index) in statusList" :key="index" :value="item.value">{{
                    item.name
                    }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="上传状态">
                <a-select
                  v-model="queryParam.reservedOne"
                  :filterOption="filterOption"
                  placeholder="请选择"
                >
                  <a-select-option value>全选</a-select-option>
                  <a-select-option value="-1">未上传</a-select-option>
                  <a-select-option value="1">一次过磅上传成功</a-select-option>
                  <a-select-option value="2">二次过磅上传成功</a-select-option>
                  <a-select-option value="4">一次过磅上传失败</a-select-option>
                  <a-select-option value="5">二次过磅上传失败</a-select-option>

                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="客户/供应商">
                <a-select
                  v-model="queryParam.supplierOrBusId"
                  showSearch
                  :filterOption="filterOption"
                  placeholder="请选择"
                  default-value="0"
                >
                  <a-select-option value>全选</a-select-option>
                  <a-select-option v-for="(item, index) in supplierOrBusList" :key="index" :value="item.id">{{
                    item.name
                    }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <!--<a-form-item label="货物名称">
                <a-input v-model.trim="queryParam.materielName" placeholder />
              </a-form-item>-->

              <a-form-item label="货物名称">

                <a-auto-complete
                  :dataSource="materielSelect"
                  style="max-width: 270px"
                  placeholder=""
                  @select="onSelect"
                  @search="handleSearch"/>
              </a-form-item>

            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="司机姓名">
                <a-input v-model.trim="queryParam.driverName" placeholder/>
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="24">
              <a-form-item
                label="皮重时间"
                :labelCol="{ lg: { span: 7 }, sm: { span: 7 } }"
                :wrapperCol="{ lg: { span: 10 }, sm: { span: 17 } }"
              >
                <a-range-picker
                  v-model="queryParam.tareTime"
                  style="width: 100%"
                  :disabledDate="disabledDate"
                  :ranges="{
                    今天: [moment().startOf('day'), moment().endOf('day')],
                    本月: [moment().startOf('month'), moment().endOf('day')],
                  }"
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  v-decorator="['dateRange', { rules: [{ required: true, message: '请选择皮重时间' }] }]"
                />
              </a-form-item>
            </a-col>

            <a-col :md="10" :sm="24">
              <a-form-item label="毛重时间">
                <a-range-picker
                  v-model="queryParam.grossTime"
                  style="width: 100%"
                  :disabledDate="disabledDate"
                  :ranges="{
                    今天: [moment().startOf('day'), moment().endOf('day')],
                    本月: [moment().startOf('month').endOf('day')],
                  }"
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  v-decorator="['dateRange', { rules: [{ required: true, message: '请选择毛重时间' }] }]"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="(!advanced && 8) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="
                  () => {
                    queryParam = {}
                    this.statusSelect = null
                  }
                "
              >重置</a-button
              >

              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button type="primary" style="margin-left: 8px" @click="handleExport()">导出</a-button>
      <!--
      <a-button style="margin-left: 0px" type="primary" @click="handleExport()">导出</a-button>

      <a-button
        v-if="roleId === config.RoleType.SUPER_ADMIN"
        style="margin-left: 8px"
        type="primary"
        @click="preview('stand')"
        >报表预览</a-button
      >
      -->
      <!--
            <a-button v-if="roleId === config.RoleType.SUPER_ADMIN" style="margin-left: 8px" type="primary" @click="previewPDF()">PDF报表预览</a-button>
      -->
      <a-button
        v-if="roleId === config.RoleType.SUPER_ADMIN"
        style="margin-left: 8px"
        type="primary"
        @click="exportExcel('stand')"
      >报表导出
      </a-button
      >

      <a-button
        v-if="roleId === config.RoleType.SUPER_ADMIN"
        style="margin-left: 8px"
        type="primary"
        @click="preview('standGroup')"
      >分组预览
      </a-button
      >
      <a-button
        v-if="roleId === config.RoleType.SUPER_ADMIN"
        style="margin-left: 8px"
        type="primary"
        @click="exportExcel('standGroup')"
      >分组导出
      </a-button
      >

      <a-button
        v-if="roleId === config.RoleType.SUPER_ADMIN"
        style="margin-left: 8px"
        type="primary"
        @click="preview('standH')"
      >分栏预览
      </a-button
      >

      <a-button
        v-if="roleId === config.RoleType.SUPER_ADMIN"
        style="margin-left: 8px"
        type="primary"
        @click="exportExcel('standH')"
      >分栏导出
      </a-button
      >
      <span style="margin-left: 40px; font-size: 16px; color: red">毛重：</span><span>{{ sumGross }}吨</span>
      <span style="margin-left: 40px; font-size: 16px; color: red">皮重：</span><span>{{ sumTare }}吨</span>
      <span style="margin-left: 40px; font-size: 16px; color: red">净重：</span><span>{{ sumNet }}吨</span>
      <span style="margin-left: 40px; font-size: 16px; color: red">车次：</span><span>{{ vehicleNum }}辆</span>
    </div>
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1900 }"
      :pagination="{ pageSizeOptions: pageSizeOptionsList, showTotal: (total) => `共${total}条` }"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>

      <span slot="supplierName" slot-scope="text, record, index">{{
        record.businessTypeId === config.BusinessTypeId.sell ? record.businessName : record.supplierName
      }}</span>

      <span slot="uploadStatus" slot-scope="text, record, index">
        <span v-if="!record.reservedOne">未上传</span>
        <span v-if="record.reservedOne === config.uploadStatus.first_success">一次过磅上传成功</span>
        <span v-if="record.reservedOne === config.uploadStatus.second_success">二次过磅上传成功</span>
        <span v-if="record.reservedOne === config.uploadStatus.first_fail" style="color: red">
          一次过磅上传失败
          <a-tooltip trigger="click" @visibleChange="showFailReason(record.weighingNo, '1')" placement="topLeft">
            <template slot="title">
              <span>{{ failReason }}</span>
            </template>
            <div>
              <a-button>查看原因</a-button>
            </div>
          </a-tooltip>
        </span>
        <span v-if="record.reservedOne === config.uploadStatus.second_fail" style="color: red">
          二次过磅上传失败
          <a-tooltip trigger="click" @visibleChange="showFailReason(record.weighingNo, '2')" placement="topLeft">
            <template slot="title">
              <span>{{ failReason }}</span>
            </template>
            <div>
              <a-button>查看原因</a-button>
            </div>
          </a-tooltip>
        </span>
      </span>

      <span slot="materielAction" slot-scope="text, record">
        <a @click="handleProDetail(record.materielVo)" class="ant-dropdown-link">{{ text }}</a>
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleDetail(record)">详情</a>
        <a-divider type="vertical" v-show="roleId === config.RoleType.ADMIN"/>
        <a-dropdown v-if="rolelimit == true">
          <a class="ant-dropdown-link">
            更多
            <a-icon type="down"/>
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a @click="Bill_Print(record)">打印磅单</a>
              <!-- <a @click="Bill_Edit()" v-if="roleId==1">编辑磅单</a>-->
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>
  </a-card>
</template>

<script>
  import Vue from 'vue'
  import {ACCESS_TOKEN} from '@/store/mutation-types'
  import Bus from '@/layouts/bus'
  import {STable} from '@/components'
  import {
    weighingPage,
    weighingUploadInfo,
    weighingUpdateWeighingInfo,
    weighingUpdate,
    baseInfoList,
    weighingExport,
    weighingOrder,
    weighingStatistics,
    dayinbangdan
  } from '@/api/logistics'
  import {getCorpSupplierList, corpBusinessList, materielList} from '@/api/basic'
  import {userList} from '@/api/sys'
  import {formatDate} from '@/utils/date.js'
  import moment from 'moment'
  import {ReservationStatus} from '@/utils/config.js'
  import {getLogStatusTextByValue, getBizTextByValue} from '@/utils/util'
  import storage from '@/utils/storage'
  import {getLodop, getITKmtBillFr3, Bill_Edit, Bill_Print} from '@/tools/lodop/LodopFuncs'
  import queryMixin from '@/mixins/queryMixin'
  import {findPrivileBycode} from '@/api/sys'
  export default {
    name: 'ReservationList',
    mixins: [queryMixin],
    components: {
      STable
    },
    data() {
      return {
        pageSizeOptionsList: ['10'],
        description: '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
        // form: null,
        sumTare: 0,
        businessSelect: [],
        materielSelect: [],
        sumGross: 0,
        sumNet: 0,
        vehicleNum: 0,
        form: this.$form.createForm(this),
        bizCodeList: {},
        // bizList: [],
        bizList: this.$store.getters.bizList,
        statusList: [],

        selectedBizId: null,
        supplierList: [],
        businessList: [],
        supplierOrBusList: [],
        supplierOrBusId: null,

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: null,
        rolelimit: false,
        roleId: null,
        failReason: '',
        bizType: '',
        scaleType: '',

        materielData: {},
        materList: [],

        LODOP: null, // 声明打印全局变量
        print: null,
        downloadUrl: this.config.downloadUrl,
        // 表头
        columns: [
          {
            title: '物流单号',
            dataIndex: 'logisticsNo',
            width: '200px',
            fixed: 'left'
          },
          {
            title: '车号',
            dataIndex: 'vehicleNo',
            width: '150px'
          },

          {
            title: '业务类型',
            dataIndex: 'businessTypeId',
            width: '110px',
            customRender: (text, record) => {
              return getBizTextByValue(this.bizList, record.businessTypeId, text)
            }
          },
          {
            title: '客户/供应商',
            dataIndex: 'supplierName',
            width: '290px',
            scopedSlots: {customRender: 'supplierName'},
            sorter: true
          },
          {
            title: '货物名称',
            dataIndex: 'materielVo.materielName',
            width: '220px',
            sorter: true
            // scopedSlots: { customRender: 'materielAction' },
          },
          {
            title: '毛重',
            dataIndex: 'gross',
            width: '100px'
          },
          {
            title: '皮重',
            dataIndex: 'tare',
            width: '100px'
          },
          {
            title: '净重',
            dataIndex: 'net',
            width: '100px'
          },
          {
            title: '预约量',
            dataIndex: 'materielVo.predictQuantity',
            width: '100px'
          },
          {
            title: '一次磅时间',
            dataIndex: 'beginTime',
            width: '180px',
            sorter: true,
            // sorter: true,
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
              }
            }
          },
          {
            title: '状态',
            dataIndex: 'logStatus',
            width: '150px',
            customRender: (text, record) => {
              return getLogStatusTextByValue(this.bizCodeList, record.businessTypeId, text)
            }
          },
          {
            title: '上传状态',
            dataIndex: 'reservedOne',
            width: '160px',
            scopedSlots: {customRender: 'uploadStatus'}
          },
          {
            title: '操作',
            width: '130px',
            fixed: 'right',
            dataIndex: 'action',
            scopedSlots: {customRender: 'action'}
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          if (this.queryParam.tareTime !== undefined && this.queryParam.tareTime.length > 1) {
            this.queryParam['tareStartTime'] = formatDate(new Date(this.queryParam.tareTime[0]), 'yyyy-MM-dd hh:mm:ss')
            this.queryParam['tareEndTime'] = formatDate(new Date(this.queryParam.tareTime[1]), 'yyyy-MM-dd hh:mm:ss')
          } else {
            this.queryParam['tareStartTime'] = null
            this.queryParam['tareEndTime'] = null
          }
          if (this.queryParam.grossTime !== undefined && this.queryParam.grossTime.length > 1) {
            this.queryParam['grossStartTime'] = formatDate(new Date(this.queryParam.grossTime[0]), 'yyyy-MM-dd hh:mm:ss')
            this.queryParam['grossEndTime'] = formatDate(new Date(this.queryParam.grossTime[1]), 'yyyy-MM-dd hh:mm:ss')
          } else {
            this.queryParam['grossStartTime'] = null
            this.queryParam['grossEndTime'] = null
          }
          if (this.queryParam.supplierOrBusId) {
            if (this.selectedBizId === this.config.BusinessTypeId.purchase) {
              this.queryParam.corpSupplierId = this.queryParam.supplierOrBusId
            }
            if (this.selectedBizId === this.config.BusinessTypeId.sell) {
              this.queryParam.corpBusinessId = this.queryParam.supplierOrBusId
            }
          } else {
            this.queryParam.corpSupplierId = null
            this.queryParam.corpBusinessId = null
          }
          weighingStatistics(Object.assign(parameter, this.queryParam))
            .then(res => {
              if (res.code == '0') {
                this.sumGross = res.data.sumGross
                this.sumTare = res.data.sumTare
                this.sumNet = res.data.sumNet
                this.vehicleNum = res.data.vehicleNum
              }
            })
          return weighingPage(Object.assign(parameter, this.queryParam)).then(res => {
            return res.data
          })


        },

        selectedRowKeys: [],
        selectedRows: []
      }
    },

    created() {
      this.loadMaterSelect()
      this.loadSelect()
      this.checkButtonPrivilege()
      this.loadSupplierSelect()
      this.loadBusinessSelect()
      this.bizCodeList = this.$store.getters.bizCodeList
      // this.bizList = this.$store.getters.bizList
      this.roleId = this.$store.getters.roles
      // 如果是超级管理员，则加载下物料数据
      if (this.roleId === this.config.RoleType.SUPER_ADMIN) {
        this.loadBaseInfoList()
      }

      // 初始化查询条件
      if (!this.queryParam) {
        this.queryParam = {
          tareTime: [moment().startOf('day'), moment().endOf('day')],
          grossTime: [moment().startOf('day'), moment().endOf('day')]
        }
      } else {
        if (this.queryParam.tareTime.length > 0) {
          this.queryParam.tareTime[0] = moment(this.queryParam.tareTime[0])
          this.queryParam.tareTime[1] = moment(this.queryParam.tareTime[1])
        }
        if (this.queryParam.grossTime.length > 0) {
          this.queryParam.grossTime[0] = moment(this.queryParam.grossTime[0])
          this.queryParam.grossTime[1] = moment(this.queryParam.grossTime[1])
        }
      }
      console.log("AASS")
      console.log(this.queryParam)
    },

    methods: {
      handleSearch(value){
        if (value) {
          this.queryParam.materielName = value
        }
      },
      onSelect(value){
        if (value) {
          this.queryParam.materielName = value
        }
      },
      loadMaterSelect() {
        new Promise(resolve => {
          const data = materielList().then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          // this.materielSelect = res
          // this.materielSelect = ['AAAAAAAAA','QQQQ']

          this.materielSelect = []
          for (var i = 0; i < res.length; i++) {
            const newData = this.materielSelect.filter(item => item == res[i].name)
            if (newData.length == 0) {
              this.materielSelect.push(res[i].name)
            }
          }
        })
      },
      loadSelect() {
        new Promise(resolve => {
          const data = corpBusinessList({}).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.businessSelect = res
        })
      },
      //分配物流记录按钮权限
      checkButtonPrivilege(record) {

        new Promise(resolve => {
          const data = findPrivileBycode({code: 'czbd-handler'}).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {

          if (res == 'czbd-handler') {
            this.rolelimit = true
          }
        })

      },
      moment,
      disabledDate(current) {
        // Can not select days before today and today
        return current && current > moment().endOf('day')
      },
      preview(reportName) {
        var tareTime = this.queryParam.tareTime
        console.log(tareTime)
        if (!tareTime) {
          tareTime = ''

        } else if (tareTime.length <= 0) {
          this.$message.warning("请选择皮重时间", 3)
          return
        }
        var tareTime_begin = ''
        var tareTime_end = ''
        var tareBeginStr = ''
        var tareEndStr = ''
        if (tareTime != '') {
          tareTime_begin = tareTime[0]._d
          tareTime_end = tareTime[1]._d
          tareBeginStr = formatDate(tareTime_begin, 'yyyy-MM-dd hh:mm:ss')
          tareEndStr = formatDate(tareTime_end, 'yyyy-MM-dd hh:mm:ss')
        }
        var type = "HTML"
        var token = Vue.ls.get(ACCESS_TOKEN)
        window.open(this.config.jasperTestUrl + type + "&reportName=" + reportName + "&standStart=" + tareBeginStr + "&standEnd=" + tareEndStr + '&accessToken=' + token, "_blank");
      },
      previewPDF() {
        var type = "PDF"
        var token = Vue.ls.get(ACCESS_TOKEN)
        window.open(this.config.jasperTestUrl + type + '&accessToken=' + token, "_blank");
      },
      exportExcel(reportName) {
        var tareTime = this.queryParam.tareTime
        if (!tareTime) {
          tareTime = ''
        } else if (tareTime.length <= 0) {
          this.$message.warning("请选择皮重时间", 3)
          return
        }
        var tareTime_begin = ''
        var tareTime_end = ''
        var tareBeginStr = ''
        var tareEndStr = ''
        if (tareTime != '') {
          tareTime_begin = tareTime[0]._d
          tareTime_end = tareTime[1]._d
          tareBeginStr = formatDate(tareTime_begin, 'yyyy-MM-dd hh:mm:ss')
          tareEndStr = formatDate(tareTime_end, 'yyyy-MM-dd hh:mm:ss')
        }
        var type = "EXCEL"
        window.location.href = this.config.jasperTestUrl + type + "&reportName=" + reportName + "&standStart=" + tareBeginStr + "&standEnd=" + tareEndStr;
      },
      loadBaseInfoList() {
        // 从后台拉去下拉列表数据
        new Promise(resolve => {
          const data = baseInfoList({}).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          /* this.materielList = res.materielList
           for (var i = 0; i < this.materielList.length; i++) {
           let materie = this.materielList[i]
           if (!(this.materielData[materie.businessTypeId] instanceof Array)) {
           this.materielData[materie.businessTypeId] = []
           }
           this.materielData[materie.businessTypeId].push(materie)
           }
           this.materList = this.materielData[this.selectedBizId]*/
        })
      },

      handleScaleChange(value) {
        this.grossShow = true
        this.tareShow = true
        if (this.mdl.bizType === this.config.BusinessTypeId.purchase && value === '1') {
          this.tareShow = false
        }
        if (this.mdl.bizType === this.config.BusinessTypeId.purchase && value === '2') {
          this.grossShow = false
        }
        // 如果是销售并且是一次过磅
        if (this.mdl.bizType === this.config.BusinessTypeId.sell && value === '1') {
          this.grossShow = false
        }
        if (this.mdl.bizType === this.config.BusinessTypeId.sell && value === '2') {
          this.tareShow = false
        }
      },
      showFailReason(weighingNo, type) {
        weighingUploadInfo({weighingNo: weighingNo})
          .then(res => {
            if (res.code === '0') {
              let uploadInfoList = res.data
              for (let i = 0; i < uploadInfoList.length; i++) {
                let uploadInfo = uploadInfoList[i]
                if (uploadInfo.type === type) {
                  this.failReason = uploadInfo.remark
                  return
                }
              }
              this.failReason = '未查找到原因'
            }
          })
          .catch(da => {
            console.log(da)
          })
      },

      handleBizChange(value) {
        this.selectedBizId = value
        this.statusList = this.bizCodeList[value]
        if (value === this.config.BusinessTypeId.purchase) {
          this.supplierOrBusList = this.supplierList
        }
        if (value === this.config.BusinessTypeId.sell) {
          this.supplierOrBusList = this.businessList
        }
      },
      loadSupplierSelect() {
        // 从后台拉去下拉列表数据
        new Promise(resolve => {
          const data = getCorpSupplierList({}).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.supplierList = res
        })
      },

      loadBusinessSelect() {
        new Promise(resolve => {
          const data = corpBusinessList({}).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.businessList = res
        })
      },

      filterOption(input, option) {
        // 用于下拉列表可搜索
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },

      handleDetail(record) {
        storage.save('cache-WeighingDetail', JSON.stringify(record))
        // this.$router.push({name: "WeighingDetail", query: {datas: JSON.stringify(record)}})
        this.$router.push({name: 'WeighingDetail'})
      },

      handleProDetail(record) {
        storage.save('cache-MaterielDetail', JSON.stringify(record))
        // this.$router.push({name: "MaterielDetail", query: {datas: JSON.stringify(record)}})
        this.$router.push({name: 'MaterielDetail'})
      },

      toggleAdvanced() {
        this.advanced = !this.advanced
      },

      handleExport() {
        var reservedOne = this.queryParam.reservedOne
        var vehicleNo = this.queryParam.vehicleNo
        var materielName = this.queryParam.materielName
        var logisticsNo = this.queryParam.logisticsNo
        var businessTypeId = this.queryParam.businessTypeId
        var logStatus = this.queryParam.logStatus
        var corpSupplierId = this.queryParam.corpSupplierId
        var corpBusinessId = this.queryParam.supplierOrBusId
        var driverName = this.queryParam.driverName
        var tareTime = this.queryParam.tareTime
        var grossTime = this.queryParam.grossTime
        if (!reservedOne) {
          reservedOne = ''
        }
        if (!vehicleNo) {
          vehicleNo = ''
        }
        if (!materielName) {
          materielName = ''
        }
        if (!logisticsNo) {
          logisticsNo = ''
        }
        if (!businessTypeId) {
          businessTypeId = ''
        }
        if (!logStatus) {
          logStatus = ''
        }
        if (!corpSupplierId) {
          corpSupplierId = ''
        }
        if (!corpBusinessId) {
          corpBusinessId = ''
        }
        if (!driverName) {
          driverName = ''
        }
        if (!tareTime) {
          tareTime = ''
        }
        if (!grossTime) {
          grossTime = ''
        }
        var tareTime_begin = ''
        var tareTime_end = ''
        var tareBeginStr = ''
        var tareEndStr = ''
        if (tareTime != '') {
          tareTime_begin = tareTime[0]._d
          tareTime_end = tareTime[1]._d
          tareBeginStr = formatDate(tareTime_begin, 'yyyy-MM-dd hh:mm:ss')
          tareEndStr = formatDate(tareTime_end, 'yyyy-MM-dd hh:mm:ss')
        }
        var grossTime_begin = ''
        var grossTime_end = ''
        var grossBeginStr = ''
        var grossEndStr = ''
        if (grossTime != '') {
          grossTime_begin = grossTime[0]._d
          grossTime_end = grossTime[1]._d
          grossBeginStr = formatDate(grossTime_begin, 'yyyy-MM-dd hh:mm:ss')
          grossEndStr = formatDate(grossTime_end, 'yyyy-MM-dd hh:mm:ss')
        }
        const token = Vue.ls.get(ACCESS_TOKEN)
        window.location.href =
          this.config.downloadWeighingUrl +
          '&accessToken=' +
          token +
          '&vehicleNo=' +
          vehicleNo +
          '&materielName=' +
          materielName +
          '&logisticsNo=' +
          logisticsNo +
          '&businessTypeId=' +
          businessTypeId +
          '&logStatus=' +
          logStatus +
          '&corpSupplierId=' +
          corpSupplierId +
          '&corpBusinessId=' +
          corpBusinessId +
          '&driverName=' +
          driverName +
          '&tareBeginStr=' +
          tareBeginStr +
          '&tareEndStr=' +
          tareEndStr +
          '&grossBeginStr=' +
          grossBeginStr +
          '&grossEndStr=' +
          grossEndStr+
        '&reservedOne=' +
          reservedOne
      },
      printPreview(record) {
        Bus.$emit('showSpinning', true, '打印中...')
        weighingOrder({id: record.id})
          .then(res => {
            if (res.code === '0') {
              this.print = res.data
              this.print.inTime = formatDate(new Date(this.print.inTime), 'yyyy-MM-dd hh:mm:ss')
              this.print.outTime = formatDate(new Date(new Date()), 'yyyy-MM-dd hh:mm:ss')
              this.print.dbDate = formatDate(new Date(new Date()), 'yyyy-MM-dd')

              console.log(this.print.dbDate);
              setTimeout(() => {
                this.createOneFormPage()


                this.LODOP.PREVIEW()
              }, 100)
            } else {
              this.$message.error(res.message)
            }
          })
          .catch(e => {
            console.log(e)
          })
          .finally(z => {
            Bus.$emit('showSpinning', false)
          })
      },
      createOneFormPage() {
        this.LODOP = getLodop(this.downloadUrl)
        console.log("状态:" + this.LODOP)
        if (this.LODOP) {
          this.LODOP.PRINT_INIT('磅单打印面板')
          console.log('磅单打印面板')
          this.LODOP.SET_PRINT_STYLE('FontSize', 18)
          this.LODOP.SET_PRINT_STYLE('Bold', 1)
          this.LODOP.ADD_PRINT_HTM(0, 0, 100, 400, document.getElementById('dy01').innerHTML)
          this.LODOP.SET_PREVIEW_WINDOW(1, 2, 1, 460, 400, '磅单打印预览.打印')
          this.LODOP.SET_PRINT_PAGESIZE(3, '214mm', '93mm', "CreateCustomPage");
          console.log('磅单打印预览.打印')
        }
      },
      Bill_Print(record) {
        console.log("进入打印" + record.id)
        weighingOrder({id: record.id})
          .then(res => {
            if (res.code === '0') {
              var kk = res.data


              $.ajax({
                type: "post",
                url: "http://127.0.0.1:5050",
                data: kk,
                //data: "{'command':'print','filename':'state.fr3','preview':true,'json':[{'value':'2021-01-22','name':'dbDate'},{'value':'04210122120501212176','name':'logisticsNo'},,{'value':'2021-01-22 12:07:45','name':'inTime'},{'value':'','name':'outTime'},{'value':'弃土','name':'materielName'},{'value':'鄂K52709','name':'vehicleNo'},{'value':'仰','name':'driverName'},{'value':'15337321113','name':'phone'},{'value':'11.34','name':'tare'},{'value':'41.16','name':'gross'},{'value':'29.82','name':'net'},{'value':'sby','name':'grossUsername'}]}",
                //  data: "{'command':'print','filename':'demo1.fr3','preview':true,'json':[{'name':'F_TITLE','value':'测试标题'},{'name':'F_LONGTEXT','value':'很长的文字内容很长的文字内容很长的文字内容很长的'}]}",
                dataType: "json",
                success: function (data) {

                },
              })

            } else {
              this.$message.error(res.message)
            }
          })
          .catch(e => {
            console.log(e)
          })
          .finally(z => {

          })

      },
      Bill_Edit() {
        Bill_Edit()
      }
    },
    watch: {}
  }
</script>